import { render, staticRenderFns } from "./editBusinessOpportunity.vue?vue&type=template&id=67edfc9f&scoped=true"
import script from "./editBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./editBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./editBusinessOpportunity.vue?vue&type=style&index=0&id=67edfc9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67edfc9f",
  null
  
)

export default component.exports